<template>
    <div class="margin-header">
        <TopBar :title="$vuetify.lang.t('$vuetify.HistoryOnsite.pageName')"/>
        <div class="box-round display-height">
            <div class="box-content pt-0 px-0">
                <div class="px-7 mt-5 d-flex">
                    <div class="px-0 pr-1 py-0" style="flex: 1;">
                        <v-text-field
                            class="custom-input-search search"
                            hide-details="auto"
                            outlined
                            :placeholder="$vuetify.lang.t('$vuetify.HistoryOnsite.search.placeholder')"
                            v-model="search"
                            @input="inputSearch()"
                        ></v-text-field>
                    </div>
                </div>
                <div class="d-flex flex-nowrap text-sm mt-4  line-liff-detail">
                    <v-col cols="6" class="px-0 py-0  pl-7 text-blue">
                        {{list.length}} {{$vuetify.lang.t('$vuetify.HistoryOnsite.people')}}
                    </v-col>
                    <v-col cols="6" class="px-0 py-0 text-right pr-7 text-base-grey2">
                        {{textDate}}
                    </v-col>
                </div>
                <div class="d-flex flex-nowrap header-item mt-4 text-sm line-liff-header-table">
                    <v-col cols="8" class="px-0 py-2  pl-7">
                        {{$vuetify.lang.t('$vuetify.HistoryOnsite.header.detail')}}
                    </v-col>
                    <v-col cols="4" class="px-0 py-2  text-right pr-7">
                        {{$vuetify.lang.t('$vuetify.HistoryOnsite.header.status')}}
                    </v-col>
                </div>
                <div class="line-liff-detail-table">
                  <div class="list-item" v-for="(v,i) of list" :key="i">
                       <div class="d-flex pt-0 pr-5 font-weight-bold">
                          <v-col cols="8 pb-1 pl-7">
                              <i class="fas fa-address-card mr-2 mb-1"></i>
                              <span>{{v.employeeId}}</span>
                          </v-col>
                      </div>
                      <div class="pl-7 pt-1 pr-5 font-weight-bold">
                          <div class="mb-2 text-truncate d-flex aligns-center">
                              <v-icon small class="mr-3">fa fa-user</v-icon>
                              <span class="text-truncate">{{v.name}}</span>
                          </div>
                      </div>
                      <div class="d-flex pt-0 pr-5 pb-2">
                          <v-col cols="8 pb-1 pl-7 pt-0 d-flex font-weight-bold">
                              <div>
                                <v-icon small class="mr-4">fas fa-map-marker-alt</v-icon>
                              </div>
                              <div class="address">{{v.address}}</div>
                          </v-col>
                          <v-col cols="4 pb-1 text-right pt-0"><small>{{v.time}}</small></v-col>
                      </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import TopBar from '@/components/Liff/Components/header/TopBar.vue'

export default {
    name: 'HistoryOnsite',
    components: {
        TopBar
    },
    data: function () {
        return {
            apiSearch: null,
            role: null,
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_HISTORY_ONSITE,
            delayTimer: null,
            date: null,
            title: null,
            search: null,
            status: null,
            list: [],
            options: [{ text: 123, value: 1234 }]
        }
    },
    computed: {
        textDate: function () {
            const lang = localStorage.getItem('lang')
            const date = this.$dateUtil.formatDate(this.date)
            const [d, m, y] = date.split('/')
            const months = this.$dateUtil.months(lang)
            return `${d} ${months[parseInt(m) - 1]} ${y}`
        }
    },
    created: function () {
        this.date = moment().format('YYYY-MM-DD')
        this.title = 'Onsite Today'
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                // get line id
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                // get profile
                const profile = await this.axios.post('line/role-profile', { lineId: this.lineUserId })
                if (profile && profile.data && profile.data.status === 'ok') {
                    this.role = profile.data.data
                    if (this.role === 'PRE' || this.role === 'HRE') {
                        this.apiSearch = 'attendances/line/hr-president/onsite/data'
                    } else if (this.role === 'HBU') {
                        this.apiSearch = 'attendances/line/head-bureau/onsite'
                    }
                }
                // get data
                const res = await this.axios.get('attendance/status/options')
                this.options = res.data.data
                this.status = res.data.data[0].value
                this.searchData()
            } catch {
                // do something with error
            }
            this.$store.dispatch('setLoading', false)
        },
        searchData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const params = {
                    lineId: this.lineUserId,
                    search: this.search,
                    status: this.status
                }
                const res = await this.axios.post(this.apiSearch, params)
                if (res && res.data && res.data.status === 'ok') {
                    this.list = res.data.data
                }
            } catch {
            }
            this.$store.dispatch('setLoading', false)
        },
        inputSearch: async function () {
            clearTimeout(this.delayTimer)
            this.delayTimer = setTimeout(this.searchData, 500)
        }
    }
}
</script>

<style lang="scss" scoped>
  @import '@/styles/color.scss';
  .address {
      line-height: 1.3;
  }
  .custom-margin {
      margin-top: -10px;
  }

  .header-item {
      margin-top: -5px;
      color: $base-grey2;
      background: #d9e4ed;
      font-size: 14px;
  }
  .list-item {
      padding: 5px 0;
      &:not(:last-child){
          border-bottom: 1px solid $base-grey4;
      }
      i {
          color: $base-grey;
      }
      span {
          color: $base-grey3;
      }
    }
    .text-ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
